import { render, staticRenderFns } from "./OperationGroupAddIframe.vue?vue&type=template&id=15629292&"
import script from "./OperationGroupAddIframe.vue?vue&type=script&lang=ts&"
export * from "./OperationGroupAddIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports